package com.castly.admin.dto

import kotlinx.serialization.Serializable

@Serializable
data class TagsResponse(
    val tags: List<TagResponse>
)
